import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { type ReactNode } from 'react';
import { I18nextProvider as Provider, initReactI18next } from 'react-i18next';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: 'translations',
    fallbackLng: 'en', // use en if detected lng is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    keySeparator: '>',

    // have a common namespace used around the full app
    ns: ['translations'],
    nsSeparator: '|',
    resources: {
      // en: {
      //   translations: translationEn,
      // },
      // 'en-US': {
      //   translations: translationEn,
      // },
      // es: {
      //   translations: translationEs,
      // },
      // 'en-CA': {
      //   translations: translationEnCa,
      // },
    },
  });

export default i18n;

export function I18nextProvider({ children }: { children: ReactNode }) {
  return (
    <Provider defaultNS='translation' i18n={i18n}>
      {children}
    </Provider>
  );
}
